// Payment Data Mappers

import {Payment, PaymentDTO} from '../models/Payment';

// DTO to Model Mappers
export const mapPaymentDTOToModel = (dto: PaymentDTO): Payment => ({
  id: dto.id.toString(),
  paymentNumber: dto.payment_number,
  invoiceId: dto.invoice_id?.toString(),
  storeId: dto.store_id,
  customerName: dto.customer_name,
  marketerDeveloperName: dto.marketer_developer_name,
  totalAmount: dto.total_amount || dto.amount || 0,
  amount: dto.amount,
  paymentMethod: (dto.payment_method as Payment['paymentMethod']) || 'نقداً',
  paymentStatus: dto.payment_status,
  paymentDate: dto.payment_date,
  referenceNumber: dto.reference_number,
  notes: dto.notes,
  processedBy: dto.processed_by?.toString(),
  processedByName: dto.processed_by_name,
  createdBy: dto.created_by,
  createdAt: dto.created_at,
  allocations: dto.allocations?.map(alloc => ({
    invoiceId: alloc.invoice_id,
    invoiceNumber: alloc.invoice_number,
    amount: alloc.amount
  }))
});

// Model to DTO Mappers
export const mapPaymentToDTO = (payment: Payment): PaymentDTO => ({
  id: parseInt(payment.id),
  payment_number: payment.paymentNumber,
  invoice_id: payment.invoiceId ? parseInt(payment.invoiceId) : undefined,
  store_id: payment.storeId,
  customer_name: payment.customerName,
  marketer_developer_name: payment.marketerDeveloperName,
  total_amount: payment.totalAmount,
  amount: payment.amount,
  payment_method: payment.paymentMethod,
  payment_status: payment.paymentStatus,
  payment_date: payment.paymentDate,
  reference_number: payment.referenceNumber,
  notes: payment.notes,
  processed_by: payment.processedBy ? parseInt(payment.processedBy) : undefined,
  processed_by_name: payment.processedByName,
  created_by: payment.createdBy,
  created_at: payment.createdAt,
  allocations: payment.allocations?.map(alloc => ({
    invoice_id: alloc.invoiceId,
    invoice_number: alloc.invoiceNumber,
    amount: alloc.amount
  }))
});

// Array Mappers
export const mapPaymentsDTOToModel = (dtos: PaymentDTO[]): Payment[] =>
  dtos.map(mapPaymentDTOToModel);

export const mapPaymentsToDTO = (payments: Payment[]): PaymentDTO[] =>
  payments.map(mapPaymentToDTO);
